import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    justify-content: center;
    align-items: flex-start;

    height: calc(100vh - 64px);
    overflow-y: auto;
    padding: 24px;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 768px) {
      padding: 0px;
      overflow-x: hidden;
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
